<template>
  <div class="news-page">
    <!-- 新闻资讯页面 -->
    <section class="news-header">
      <div class="container">
        <h1 class="page-title">新闻资讯</h1>
        <p class="page-subtitle">关注中政量化研究院的最新动态</p>
      </div>
    </section>
    
    <!-- 新闻列表 -->
    <section class="news-list-section" id="news-list">
      <div class="container">
        <div class="news-list">
          <el-skeleton :rows="3" animated v-if="loading" style="margin: 20px 0;"></el-skeleton>
          <div v-else-if="newsList.length > 0">
            <div class="news-item" v-for="(news, idx) in newsList" :key="idx">
              <div class="news-info">
                <div class="news-date">{{ news.date }}</div>
                <h3 class="news-title">{{ news.title }}</h3>
                <p class="news-desc">{{ news.desc }}</p>
                <el-button type="text" @click="viewNewsDetail(news.id)">查看详情 <i class="el-icon-right"></i></el-button>
              </div>
            </div>
          </div>
          <div v-else class="no-data">
            <el-empty description="暂无新闻数据"></el-empty>
          </div>
        </div>
        
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            layout="total, prev, pager, next"
            :total="totalNews"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { newsAPI } from '../services/api';

export default {
  name: 'News',
  data() {
    return {
      newsList: [],
      totalNews: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false
    };
  },
  created() {
    this.fetchNewsList();
  },
  methods: {
    async fetchNewsList() {
      this.loading = true;
      try {
        const data = await newsAPI.getNewsList(this.currentPage, this.pageSize);
        if (data.success) {
          // 确保数据结构与Home页面的动态咨询一致
          if (Array.isArray(data.data)) {
            // 兼容旧格式直接返回数组的情况
            this.newsList = data.data.map(item => ({
              id: item.id,
              title: item.title,
              desc: item.summary || item.desc || '', // 支持summary或desc字段
              date: item.date,
              image: item.image
            }));
            this.totalNews = data.data.length;
          } else if (data.data && data.data.newsList) {
            // 新格式带分页的情况
            this.newsList = data.data.newsList.map(item => ({
              id: item.id,
              title: item.title,
              desc: item.summary || item.desc || '', // 支持summary或desc字段
              date: item.date,
              image: item.image
            }));
            this.totalNews = data.data.pagination.total;
          }
        } else {
          console.error('获取新闻列表失败:', data.message);
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    viewNewsDetail(id) {
      // 跳转到新闻详情页
      this.$router.push(`/news/${id}`).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('导航错误:', err);
        }
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchNewsList();
    }
  }
};
</script>

<style scoped>
.news-page {
  background: #f5f7fa;
  min-height: 100vh;
  padding-top: 74px;
}

.news-header {
  background: linear-gradient(135deg, #0b2b4c, #061528);
  color: #fff;
  padding: 80px 0 40px;
  text-align: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  font-size: 42px;
  margin: 0 0 10px;
  font-weight: 300;
}

.page-subtitle {
  font-size: 18px;
  margin: 0;
  opacity: 0.8;
  font-weight: 300;
}

.news-list-section {
  padding: 60px 0;
}

.news-list {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.news-item {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s ease;
}

.news-item:last-child {
  border-bottom: none;
}

.news-item:hover {
  background-color: #fafafa;
}

.news-info {
  max-width: 800px;
}

.news-date {
  font-size: 13px;
  color: #909399;
  margin-bottom: 10px;
}

.news-title {
  font-size: 20px;
  font-weight: 600;
  color: #304156;
  margin-bottom: 12px;
  line-height: 1.4;
}

.news-desc {
  font-size: 15px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination {
  margin-top: 30px;
  text-align: center;
}

@media (max-width: 768px) {
  .news-page {
    padding-top: 64px;
  }
  
  .news-header {
    padding: 50px 0 25px;
  }
  
  .page-title {
    font-size: 32px;
  }
  
  .page-subtitle {
    font-size: 16px;
  }
  
  .news-list-section {
    padding: 30px 0;
  }
  
  .news-item {
    padding: 16px;
  }
  
  .news-title {
    font-size: 18px;
  }
  
  .news-desc {
    font-size: 14px;
  }
  
  .pagination {
    margin-top: 24px;
  }
}

@media (max-width: 480px) {
  .news-header {
    padding: 40px 0 20px;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .page-subtitle {
    font-size: 15px;
  }
  
  .news-list-section {
    padding: 24px 0;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .news-item {
    padding: 12px;
  }
  
  .news-title {
    font-size: 16px;
  }
  
  .news-desc {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .news-date {
    font-size: 12px;
    margin-bottom: 8px;
  }
  
  .pagination {
    margin-top: 20px;
  }
}
</style>